import { useSession } from "providers/SessionProvider";
import React, { PropsWithChildren } from "react";
import { useNavigate } from "react-router";
import { DashboardPaths } from "routes/DashboardRouter";
import { FoundationPaths } from "routes/FoundationRouter";
import { IntegrationPaths } from "routes/IntegrationRouter";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { LmsPaths } from "routes/LmsRouter";
import { RootPaths } from "routes/RootRouter";
import { SideBarFindCurrentOption } from "./Sidebar";

export type OutsideOptions =
    | "home"
    | "lms"
    | "knowledge"
    | "performance"
    | "goals"
    | "feedback"
    | "career"
    | "dashboard"
    | "setup"
    ;


export type OutsideLayoutContextType = {
    selectedOption: OutsideOptions;
    changeOption: (value: OutsideOptions) => void;
};

export const OutsideLayoutContext = React.createContext<OutsideLayoutContextType>(null!);

export const useOutsideLayout = () => React.useContext(OutsideLayoutContext);

/**
 * Fornece um contexto de Sessão
 * @param param0
 */
export const OutsideLayoutProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const session = useSession();
    const [sidebarOption, setSidebarOption] = React.useState<OutsideOptions>(SideBarFindCurrentOption());
    const navigate = useNavigate();

    const changeOption = (value: OutsideOptions) => {
        setSidebarOption(value);
        switch (value) {
            case "home": navigate(RootPaths.Home); break;
            case "knowledge": navigate(KnowledgePaths.FeedStartup); break;
            case "lms": navigate(LmsPaths.Prefix); break;
            case "setup": navigate(FoundationPaths.Home); break;
            case "performance": navigate(IntegrationPaths.Performance); break;
            case "goals": navigate(IntegrationPaths.Goals); break;
            case "dashboard": {
                if (session.permissionExplorer.canViewAdvDashboards) {
                    navigate(DashboardPaths.Home);
                } else {
                    navigate(DashboardPaths.UserEvolution);
                }
                break;
            }
        }
    };

    return (
        <OutsideLayoutContext.Provider
            value={
                {
                    selectedOption: sidebarOption,
                    changeOption: changeOption
                }
            }
        >
            {children}
        </OutsideLayoutContext.Provider >
    );
};
